// FTEDN Creator — Community Board (wired to real data)
import { useEffect, useState } from 'react';
import { useCommunityStore } from '../../stores/community.store';
import { useUserStore } from '../../stores/user.store';
import { CommunityPostCard } from './CommunityPostCard';
import { NewPostForm } from './NewPostForm';
import { ReferralPanel } from './ReferralPanel';
import { Leaderboard } from './Leaderboard';
import { Skeleton } from '../../components/ui/Skeleton';
import { EmptyState } from '../../components/ui/EmptyState';
import './CommunityPage.css';

type Tab = 'feed' | 'referral' | 'leaderboard';

export function CommunityPage() {
  const [showNewPost, setShowNewPost] = useState(false);
  const [tab, setTab] = useState<Tab>('feed');
  const { posts, loading, fetchPosts, likePost } = useCommunityStore();
  const { profile } = useUserStore();

  useEffect(() => {
    fetchPosts();
  }, [fetchPosts]);

  return (
    <div className="community-page page-enter">
      <div className="community-header">
        <div>
          <h1>💬 Community</h1>
          <p className="community-subtitle">Connect with fellow Eeduners</p>
        </div>
        <div className="community-header-right">
          <button className="neo-btn neo-btn--primary" onClick={() => setShowNewPost(!showNewPost)} id="new-post-btn">
            {showNewPost ? '✕ Close' : '✏️ New Post'}
          </button>
        </div>
      </div>

      {/* Tab navigation */}
      <div className="community-tabs">
        <button className={`community-tab ${tab === 'feed' ? 'active' : ''}`} onClick={() => setTab('feed')}>
          💬 Feed
        </button>
        <button className={`community-tab ${tab === 'referral' ? 'active' : ''}`} onClick={() => setTab('referral')}>
          🌱 Referrals
        </button>
        <button className={`community-tab ${tab === 'leaderboard' ? 'active' : ''}`} onClick={() => setTab('leaderboard')}>
          🏆 Leaderboard
        </button>
      </div>

      {showNewPost && <NewPostForm onClose={() => { setShowNewPost(false); fetchPosts(); }} />}

      {tab === 'feed' && (
        loading ? (
          <div className="community-feed"><Skeleton variant="card" count={4} /></div>
        ) : posts.length === 0 ? (
          <EmptyState icon="💬" title="No posts yet" description="Be the first to share with the community!" />
        ) : (
          <div className="community-feed">
            {posts.map((post, i) => (
              <CommunityPostCard
                key={post.id}
                post={{
                  ...post,
                  avatar: post.author.slice(0, 1),
                  level: post.authorLevel,
                  time: post.createdAt,
                }}
                index={i}
                onLike={() => likePost(post.id)}
              />
            ))}
          </div>
        )
      )}

      {tab === 'referral' && (
        <ReferralPanel userId={profile?.id ?? ''} />
      )}

      {tab === 'leaderboard' && (
        <Leaderboard />
      )}
    </div>
  );
}
